import $ from "jquery";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { debounce } from "throttle-debounce";

const BREAKPOINT_SM_MAX = window.matchMedia("(max-width: 767.98px)");
const SELECTOR_SWIPER_CONTAINER = ".swiper-container";
const SWIPER_SETTINGS = {
  modules: [Navigation, Pagination],
  slidesPerView: "1",
  grabCursor: true,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
};
let swiper;

const createSwiper = function () {
  $(SELECTOR_SWIPER_CONTAINER).each(function (index) {
    $(this).addClass(`slider-${index}`);
    swiper = new Swiper(`.slider-${index}`, SWIPER_SETTINGS);
  });
};

const destroySwiper = function () {
  if (swiper !== undefined) swiper.destroy(true, true);
};

const initSwiper = debounce(
  250,
  () => {
    if (BREAKPOINT_SM_MAX.matches) {
      if (!$(SELECTOR_SWIPER_CONTAINER).attr("data-init")) {
        $(SELECTOR_SWIPER_CONTAINER).attr("data-init", true);
        createSwiper();
      }
    } else {
      $(SELECTOR_SWIPER_CONTAINER).removeAttr("data-init");
      destroySwiper();
    }
  },
  { atBegin: true },
);

const init = function () {
  // ON LOAD
  initSwiper();

  // ON RESIZE
  BREAKPOINT_SM_MAX.addListener(initSwiper);
};

if (window.Drupal) {
  window.Drupal.behaviors.carousel = {
    attach() {
      init();
    },
  };
} else {
  $(function () {
    init();
  });
}

$(document).on("storybook:component:change", function () {
  init();
});
